<section class="estimate-modify-session mb-4" data-testid="estimate-modify-session">
  <mat-card class="estimate-modify-session__summary card-table ml-0 mr-0 mb-0" data-balance-summary-panel>
    <mat-card-title class="estimate-modify-session__summary-title">
      <span class="estimate-modify-session__summary-title-label">
        {{ 'balance.title' | translate }}
        <mmx-modify-session-header
          [status]="vm.modifySession.isModifying ? null : (vm.status?.workflowStatus ?? null)"
          [isModifying]="vm.modifySession.isModifying"
        ></mmx-modify-session-header>
      </span>

      <mmx-modify-session-action-bar
        class="estimate-modify-session__summary-actions"
        [phase]="vm.modifySession.phase"
        [canModify]="vm.modifySession.canModify"
        [canCalculate]="vm.modifySession.canCalculate"
        [canFinalize]="vm.modifySession.canFinalize"
        [canSend]="vm.summaryCapabilities.canSend"
        [canSendEmail]="vm.summaryCapabilities.canSendEmail"
        [canSendSms]="vm.summaryCapabilities.canSendSms"
        [canSendDocument]="vm.summaryCapabilities.canSendDocument"
        [canPrintLetter]="vm.summaryCapabilities.canPrintLetter"
        [canViewHistory]="vm.summaryCapabilities.canViewHistory"
        [canVoid]="vm.modifySession.canVoid"
        [busy]="busy"
        (modify)="modify.emit()"
        (discard)="discard.emit()"
        (calculate)="calculate.emit()"
        (finalize)="finalize.emit()"
        (send)="send.emit($event)"
        (sendDocument)="sendDocument.emit()"
        (printLetter)="printLetter.emit()"
        (viewHistory)="viewHistory.emit()"
        (void)="void.emit()"
      ></mmx-modify-session-action-bar>
    </mat-card-title>
  </mat-card>

  <mat-accordion multi class="estimate-modify-session__accordion">
    <mmx-modify-session-section section="balances" [expanded]="true">
      <mmx-estimate-review-multi-visit
        [vm]="vm.multiVisitReview"
        [busy]="busy"
        [hideFinalize]="true"
        [embedded]="true"
        [diff]="vm.modifySession.diff"
        (pbTrace)="pbTrace.emit($event)"
        (hbTrace)="hbTrace.emit($event)"
        (chargeBreakdown)="chargeBreakdown.emit($event)"
      ></mmx-estimate-review-multi-visit>
    </mmx-modify-session-section>

    <mmx-modify-session-section section="charges" [expanded]="chargesExpandedByDefault">
      <mmx-balance-charges-panel
        [estimate]="vm.estimate"
        [estimateForm]="estimateForm"
        [appointmentOptions]="appointmentOptions"
        [claimSearchEnabled]="vm.claimSearchEnabled"
        [claimSearchPrefillQuery]="vm.claimSearchPrefillQuery"
        [patientType]="vm.patientType"
        [cocMode]="vm.cocMode"
        [unscheduledSelected]="vm.unscheduled"
        [readOnly]="readOnly"
        [hideCalculate]="true"
        (reset)="chargesReset.emit($event)"
        (templateSelected)="templateSelected.emit($event)"
        (appointmentSelectionChange)="appointmentSelectionChange.emit($event)"
        (cocModeChange)="cocModeChange.emit($event)"
        (unscheduledChange)="unscheduledChange.emit($event)"
        (addDiscountControl)="addDiscount.emit($event)"
        (removeDiscountControl)="removeDiscount.emit($event)"
        (chargesChanged)="chargesChanged.emit()"
      ></mmx-balance-charges-panel>
    </mmx-modify-session-section>

    <mmx-modify-session-section section="insurances">
      <!-- Wrapper carries the projection marker; *appHasPermission must stay on a
           child or its desugared <ng-template> (lacking the marker) would fall
           into the default body slot instead of the header. -->
      <span modifySessionSectionAction>
        <button
          *appHasPermission="'patient-insurance.edit'"
          type="button"
          mat-stroked-button
          [hidden]="readOnly"
          (click)="$event.stopPropagation(); insurancesCard.onAddInsuranceClick()"
          class="mr-2"
        >
          <mat-icon>add</mat-icon>
          <span>{{ 'patient-details.insurance-card.button-add' | translate }}</span>
        </button>
      </span>
      <mmx-insurances-card #insurancesCard [readOnly]="readOnly" [embedded]="true" [visitAppointment]="vm.visitAppointment" [visitAppointments]="vm.visitAppointments"></mmx-insurances-card>
    </mmx-modify-session-section>

    <mmx-modify-session-section section="benefits">
      <!-- Wrapper carries the projection marker and stops the click from
           toggling the panel; the options menu lives in the header instead of
           the panel's (now hidden) title row. -->
      <span modifySessionSectionAction (click)="$event.stopPropagation()">
        <mmx-balance-benefits-options-menu
          *ngIf="!readOnly"
          [form]="benefitsForm"
          [hasSecondaryInsurance]="vm.hasSecondaryInsurance"
          (committed)="benefitsChanged.emit()"
        ></mmx-balance-benefits-options-menu>
      </span>

      <mmx-balance-benefits-panel
        [form]="benefitsForm"
        [primaryLoading]="vm.primaryBenefitsLoading"
        [secondaryLoading]="vm.secondaryBenefitsLoading"
        [originalPrimary]="vm.estimate?.originalBenefits ?? null"
        [originalSecondary]="vm.estimate?.originalSecondaryBenefits ?? null"
        [hasSecondaryInsurance]="vm.hasSecondaryInsurance"
        [primaryInsuranceOptions]="vm.primaryInsuranceOptions"
        [secondaryInsuranceOptions]="vm.secondaryInsuranceOptions"
        [primaryInsurance]="vm.primaryInsurance"
        [insuranceSelectionResolved]="vm.insuranceSelectionResolved"
        [secondaryInsurance]="vm.secondaryInsurance"
        [readOnly]="readOnly"
        [embedded]="true"
        (benefitsChanged)="benefitsChanged.emit()"
        (primaryInsuranceChange)="primaryInsuranceChange.emit($event)"
        (secondaryInsuranceChange)="secondaryInsuranceChange.emit($event)"
      ></mmx-balance-benefits-panel>
    </mmx-modify-session-section>

    <mmx-modify-session-section *ngIf="vm.charityCareVisible" section="charity-care">
      <div class="estimate-modify-session__charity-body">
        <mmx-charity-care-summary
          [patientCharityCareStatus]="vm.patientCharityCareStatus ?? undefined"
          [timezone]="vm.charityCareTimezone ?? undefined"
          [patientId]="vm.estimate?.patientId ?? undefined"
        ></mmx-charity-care-summary>
      </div>
    </mmx-modify-session-section>
  </mat-accordion>
</section>
